import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import {
	Avatar,
	Button,
	Card,
	CardContent,
	CardHeader,
	Divider,
	Grid2,
	Typography
} from '@mui/material';

import getInitials from 'utils/getInitials';
import { Label } from 'components';

const useStyles = makeStyles((theme) => ({
	root: {},
	header: {
		paddingBottom: 0,
	},
	content: {
		padding: 10,
		'&:last-child': {
			paddingBottom: 0,
		},
	},
	description: {
		padding: theme.spacing(2, 3, 1, 3),
	},
	tags: {
		padding: theme.spacing(0, 3, 1, 3),
		'& > * + *': {
			marginLeft: theme.spacing(1),
		},
	},
	detailsButton: {
		color: theme.palette.primary.main
	},
	deleteButton: {
		color: theme.palette.error.main,
	},
	details: {
		padding: theme.spacing(1, 3),
	},
	avatar: {
		width: theme.spacing(15),
		height: theme.spacing(15),
		fontSize: theme.spacing(7)
	},
}));

const OperatorCard = (props) => {
	const { operator, deleteOperator, navigateDetails, className, ...rest } = props;

	const classes = useStyles();

	return (
		<Card {...rest} className={clsx(classes.root, className)}>
			<CardHeader
				avatar={(
					<Avatar alt="Author" className={classes.avatar} src={operator.avatar}>
						{getInitials(operator.name)}
					</Avatar>
				)}
				className={classes.header}
				disableTypography
				title={(
					<Typography
						color="textPrimary"
						variant="h5"
					>
						{operator.name}
					</Typography>
				)}
			/>
			<CardContent className={classes.content}>
				<div className={classes.tags}>
					<Label color="green" key={`operatorUsers${operator.id}`}>
						{operator.users}
						{' '}
						users
					</Label>
					<Label color="blue" key={`operatorProjects${operator.id}`}>
						{operator.projects}
						{' '}
						projects
					</Label>
				</div>
				<Divider />
				<div className={classes.details}>
					<Grid2
						alignItems="right"
						container
						justifyContent="space-between"
						spacing={3}
					>
						<Grid2 item>
							<Button
								onClick={() => navigateDetails(operator.id)}
								className={classes.detailsButton}
								size="small"
							>
								Details
							</Button>
						</Grid2>
						<Grid2 item>
							<Button
								className={classes.deleteButton}
								size="small"
								onClick={() => deleteOperator(operator)}
							>
								Delete
							</Button>
						</Grid2>
					</Grid2>
				</div>
			</CardContent>
		</Card>
	);
};

OperatorCard.propTypes = {
	className: PropTypes.string,
	operator: PropTypes.object.isRequired,
	deleteOperator: PropTypes.func,
	navigateDetails: PropTypes.func,
};

export default OperatorCard;
